export default [
    {
        id: 1,
        title: "Cred",
        coverImg: "cred.webp",
        route: "cred",

    },
    {
        id: 2,
        title: "Hotstar",
        coverImg: "hotstar.webp",
        route: "hotstar",
    },
    {
        id: 3,
        title: "Flipkart",
        coverImg: "flipkart.webp",
        route: "flipkart",
    },
    {
        id: 4,
        title: "PhonePe",
        coverImg: "phonepe.webp",
        route: "phonepe",
    },
    {
        id: 5,
        title: "PayTm",
        coverImg: "paytm.webp",
        route: "paytm",
    },
    // {
    //     id: 6,
    //     title: "Meesho",
    //     coverImg: "meesho.webp",
    //     route: "meesho",
    // }
    // ,
    {
        id: 6,
        title: "ShareChat",
        coverImg: "sharechat.webp",
        route: "sharechat",
    }
]
